import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { Modal } from '@/components/ui/Modal'
import { useState } from 'react'

interface NavigateButtonProps {
  address: string
  variant?: 'light' | 'primary' | 'default'
  /** Icon-only round button for collapsed state */
  iconOnly?: boolean
  className?: string
}

export const NavigateButton = ({
  address,
  variant = 'primary',
  iconOnly = false,
  className,
}: NavigateButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openGoogleMaps = () => {
    const encodedAddress = encodeURIComponent(address)
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`,
      '_blank'
    )
    setIsModalOpen(false)
  }

  const openAppleMaps = () => {
    const encodedAddress = encodeURIComponent(address)
    window.open(`https://maps.apple.com/?daddr=${encodedAddress}`, '_blank')
    setIsModalOpen(false)
  }

  const openWaze = () => {
    const encodedAddress = encodeURIComponent(address)
    window.open(
      `https://waze.com/ul?q=${encodedAddress}&navigate=yes`,
      '_blank'
    )
    setIsModalOpen(false)
  }

  return (
    <>
      {iconOnly ? (
        <Button
          icon={<Icon name="navigation" />}
          variant={variant}
          rounded
          onClick={() => setIsModalOpen(true)}
          className={className}
          testId="navigate-button-icon"
        />
      ) : (
        <Button
          text="Navigate"
          icon={<Icon name="navigation" size={16} />}
          iconPosition="left"
          variant={variant}
          onClick={() => setIsModalOpen(true)}
          className={className}
          testId="navigate-button"
        />
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Choose map for navigation"
        buttonLayout="column"
        testId="navigate-modal"
        buttons={[
          <Button
            key="google"
            text="Google Maps"
            variant="light"
            icon={<Icon name="external-link" size={16} />}
            onClick={openGoogleMaps}
            testId="navigate-modal-google"
          />,
          <Button
            key="apple"
            text="Apple Maps"
            variant="light"
            icon={<Icon name="external-link" size={16} />}
            onClick={openAppleMaps}
            testId="navigate-modal-apple"
          />,
          <Button
            key="waze"
            text="Waze"
            variant="light"
            icon={<Icon name="external-link" size={16} />}
            onClick={openWaze}
            testId="navigate-modal-waze"
          />,
          <Button
            key="back"
            text="Go back"
            variant="default"
            onClick={() => setIsModalOpen(false)}
            testId="navigate-modal-back"
          />,
        ]}
      />
    </>
  )
}
